import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription } from '@/components/ui/alert';

/**
 * Shown when the confirm-context call fails. There is nothing to retry from
 * inside the dialog — the quantities, locations and date window all come from
 * that one response — so it points the user at closing and reopening.
 */
export function ConfirmArrivalContextError() {
  const { t } = useTranslation();

  return (
    <Alert variant="destructive">
      <AlertDescription>
        {t(
          'receive.confirm.error.contextFailed',
          'Failed to load the receipt details. Please close the dialog and try again.'
        )}
      </AlertDescription>
    </Alert>
  );
}
